import { render, staticRenderFns } from "./select-duplicate-contacts-step.vue?vue&type=template&id=4c394c11"
import script from "./select-duplicate-contacts-step.vue?vue&type=script&lang=js"
export * from "./select-duplicate-contacts-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports